import Vue from 'vue';
import mixpanel from 'mixpanel-browser';
mixpanel.init(process.env.VUE_APP_MIXPANEL_TOKEN,);

// ENV verification to catch only prod events
let env_check = process.env.NODE_ENV === 'production';

let actions = new Vue({
  methods: {
    identify: (id,) => {
      if (env_check) {mixpanel.identify(id,);}
    },
    alias: (id,) => {
      if (env_check) {mixpanel.alias(id,);}
    },
    track: (name, props,) => {
      if (env_check) {mixpanel.track(name, props,);}
    },
    setPeople: (props,) => {
      if (env_check) {mixpanel.people.set(props,);}
    },
    incrementPeople: (props,) => {
      if (env_check) {mixpanel.people.increment(props,);}
    },
  },
},);

export default {
  install: function (Vue,) {
    Vue.prototype.$mixpanel = actions;
  },
};
